import { Application } from '@packlink/packlink-sdk';

const DEFAULT_NAMESPACE = 'common';
// These IDs are used to load the correct translations from the CDN
const PROJECT_ID = {
  // Auth flow
  [Application.AUTH]: 'auth',
  // Bulk flow
  [Application.BULK]: 'pro',
  // Consumer flow
  [Application.CHECKOUT]: 'packlink-com',
  // Single flow
  [Application.SINGLE_FLOW]: 'single-flow'
};

export { DEFAULT_NAMESPACE, PROJECT_ID };
//# sourceMappingURL=config.js.map
